import { css } from 'styled-components';

/**
 * Thin, theme-colored scrollbar for any `overflow: auto/scroll` container.
 * Windows renders full-width opaque native scrollbars by default (unlike
 * macOS's thin overlay ones); this keeps the scroll affordance without the
 * OS chrome clashing with the dark theme.
 */
export const THIN_SCROLLBAR = css`
  scrollbar-width: thin;
  scrollbar-color: var(--border-color) transparent;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--border-color);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: var(--button-color-dark);
  }
`;
